/*=============================================== NavList styles ===============================================*/

import styled from "styled-components/macro"
import { Mixins, Transitions, Icon, Spacers } from "tsx-library-julseb"

export const StyledNavList = styled.div`
    max-height: 24px;
    ${Mixins.Flexbox({
        $flexDirection: "column",
        $alignItems: "stretch",
        $gap: "xs",
    })}
    transition: ${Transitions.Long};
    overflow: hidden;

    &.open {
        max-height: 300vh;
    }

    & > a {
        padding-left: ${Spacers.XL} !important;
    }
`

export const CategoryButton = styled.button``

export const ChevronDown = styled(Icon)`
    transform: rotate(-90deg);
    transition: ${Transitions.Long};

    &.open {
        transform: rotate(0deg);
    }
`
